import { CircleCheck, LoaderCircle, XIcon } from 'lucide-react';
import styled from 'styled-components';

export const IcdProcessingBannerBox = styled.div.attrs({
  className: 'flex items-center gap-3 bg-vantis-pastelblue px-4 py-3 text-foreground',
  role: 'status',
})``;

export const IcdProcessingBannerIcon = styled(LoaderCircle).attrs({
  className: 'size-5 shrink-0 animate-spin',
  'aria-hidden': true,
})``;

export const IcdProcessingBannerText = styled.div.attrs({
  className: 'min-w-0',
})``;

export const IcdProcessingBannerTitle = styled.p.attrs({
  className: 'text-sm font-medium',
})``;

export const IcdProcessingBannerSubtext = styled.p.attrs({
  className: 'text-sm',
})``;

export const IcdCompleteBannerBox = styled.div.attrs({
  className: 'flex items-center justify-between gap-4 bg-emerald-600 px-4 py-3',
  role: 'status',
})``;

export const IcdCompleteBannerText = styled.div.attrs({
  className: 'flex items-center gap-3 min-w-0',
})``;

export const IcdCompleteBannerIcon = styled(CircleCheck).attrs({
  className: 'size-5 shrink-0 text-white',
  'aria-hidden': true,
})``;

export const IcdCompleteBannerMessage = styled.p.attrs({
  className: 'text-sm text-white',
})``;

export const IcdCompleteBannerDismissButton = styled.button.attrs({
  className:
    'flex shrink-0 size-8 items-center justify-center rounded-full border border-white text-white hover:bg-white/10',
})``;

export const IcdCompleteBannerCloseIcon = styled(XIcon).attrs({
  className: 'size-4',
  'aria-hidden': true,
})``;
